import { getDateTimeFormatter } from '@fe/core';
import { GDFIataTurbRecord } from '../../../gdf/type';
import getTimeAgo from './common/time-ago';

export default function IataTurbulenceTooltip({ record }: { record: GDFIataTurbRecord }) {
    const formatter = getDateTimeFormatter();
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '1rem' }}>
                <div>Reported at:</div>
                <div>{formatter.formatTime(record.reportTime, 'hm') || '-'}</div>

                <div>Report age:</div>
                <div>{getTimeAgo(record.reportTime)}</div>

                <div>Latitude:</div>
                <div>{record.point[1].toFixed(4)}</div>

                <div>Longitude:</div>
                <div>{record.point[0].toFixed(4)}</div>

                <div>Altitude</div>
                <div>
                    {record.altitude === null && '-'}
                    {record.altitude !== null && (record.altitude - 1000).toLocaleString('en-US') + 'ft'}
                </div>

                <div>Mean EDR</div>
                <div>
                    {record.meanEdr === null && '-'}
                    {record.meanEdr !== null && (record.meanEdr / 1000).toFixed(3)}
                </div>

                <div>Peak EDR</div>
                <div>
                    {record.peakEdr === null && '-'}
                    {record.peakEdr !== null && (record.peakEdr / 1000).toFixed(3)}
                </div>

                <div>Wind speed</div>
                <div>
                    {record.windSpeed === null && '-'}
                    {record.windSpeed !== null && record.windSpeed + 'kts'}
                </div>

                <div>Wind dir:</div>
                <div>
                    {record.windDir === null && '-'}
                    {record.windDir !== null && record.windDir + '°'}
                </div>

                <div>Temperature</div>
                <div>
                    {record.temp == null && '-'}
                    {record.temp !== null && record.temp + '°C'}
                </div>
            </div>
        </div>
    );
}
